module.exports = __webpack_public_path__ + "img/jingzhuang10.5a9a9036.jpg";